define(function() {
	var Backbone = require('backbone');
	var theModel = require('../models/address_model');
	const builder = require('civicsUtils/buildUrlParameters');
	const IpsModelCollection = require('civicsBase/ipsModelCollection');
	//site types
	const address = 'address';
	const parcel = 'parcel';
	const asset = 'asset';
	const property = 'property';
	return IpsModelCollection.extend({
		model: theModel,
		urlRoot:'/delegate/civics-api/api/',
		urlAttributes:null,
		url: function() {
			if(this.urlAttributes){
				var url = this.urlRoot;
				if (this.siteType == address) {
					url += 'property/addresses/'
				} else if (this.siteType == parcel) {
					url += 'property/parcels/'
				} else if (this.siteType == asset) {
					url += 'assetmanagement/commonassets/'
				} else {
					return;
				}
				//console.log('urlatts',this.urlAttributes);
				url = url + builder.buildUrlParameters(this.urlAttributes);

				//add IsEffective and IsExpired flags
				if( url.indexOf("?") >= 0 ){
					url += "&";
				}else {
					url += "?"
				}
				return url + "IsEffective=true&IsExpired=false";
			}
		},
		parse: function(response) {
			
			//This call will return an array if no ID is passed in, and an object if it is.
			//the advanced location view uses this collection with an ID always, so when it's an object, we add the site type
			//for ease of use.
			if (!Array.isArray(response.data)) {
				response.data._siteType = this.siteType;
				response.data._displayText = this.siteType == parcel ? response.data.parcelId : response.data.displayText;
			} else {
				if(this.siteType == parcel){
					for(var i=0;i<response.data.length;i++){
						response.data[i].type='Parcel';
					}
				}
			}
			return response.data;
		},
	});
});
